module.exports = __webpack_public_path__ + "static/img/刀.68a36ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wuqi/刀.png
// module id = 63Oy
// module chunks = 3